/* components/ui/Spinner.jsx — SVG-спиннер + полноэкранный загрузчик.
   Spinner: размеры sm(16)/md(24)/lg(32)/xl(48). Использует Icon.spinner.
   FullScreenSpinner: оверлей с центрированным спиннером — загрузка приложения.
   ХЕНДОФФ → frontend/components/common/Spinner.jsx. */

import ReactDOM from 'react-dom';
import { Icon } from './Icon.jsx';
import { getOverlayRoot } from '../../lib/overlay.jsx';

  const SIZE = { sm: 16, md: 24, lg: 32, xl: 48 };

  function Spinner({ size = 'md', label, className }) {
    const px = SIZE[size] || SIZE.md;
    return (
      <span className={'spinner spinner--' + size + (className ? ' ' + className : '')} role="status">
        <Icon name="spinner" size={px} />
        {label && <span className="spinner__label t-body-sm text-dim">{label}</span>}
      </span>
    );
  }

  function FullScreenSpinner({ label = 'Загрузка…' }) {
    return ReactDOM.createPortal(
      <div className="fullscreen-spinner" role="status" aria-live="polite">
        <Spinner size="xl" />
        {label && <div className="fullscreen-spinner__label t-body text-dim">{label}</div>}
      </div>,
      getOverlayRoot()
    );
  }

export { Spinner };
export { FullScreenSpinner };
